function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FalklandIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "c",
        width: "14",
        height: "11",
        x: "0",
        y: "3",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 3h13.5v10.5H0z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "m-1.503 12.75 2.97 1.303 12.1-9.636 1.567-1.937-3.176-.435-4.936 4.152L3.05 8.995l-4.553 3.755Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "m-1.097 13.663 1.514.756L14.572 2.3h-2.125L-1.096 13.663Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "m15.003 12.75-2.97 1.303-12.1-9.636-1.567-1.937 3.176-.435 4.936 4.152 3.972 2.798 4.553 3.755Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "m14.902 13.405-1.514.756-6.027-5.188-1.787-.58-7.36-5.906H.34l7.355 5.766 1.954.695 5.253 4.457Z"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "d",
          width: "16",
          height: "13",
          x: "-1",
          y: "2",
          fill: "#000",
          maskUnits: "userSpaceOnUse",
          children: [/*#__PURE__*/_jsx("path", {
            fill: "#fff",
            d: "M-1 2h16v13H-1z"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
            clipRule: "evenodd"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          fillRule: "evenodd",
          d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F7FCFF",
          d: "M5.988 3v-.75h-.75V3h.75Zm1.5 0h.75v-.75h-.75V3Zm-1.5 4.5v.75h.75V7.5h-.75ZM0 7.5v-.75h-.75v.75H0ZM0 9h-.75v.75H0V9Zm5.988 0h.75v-.75h-.75V9Zm0 4.5h-.75v.75h.75v-.75Zm1.5 0v.75h.75v-.75h-.75Zm0-4.5v-.75h-.75V9h.75ZM13.5 9v.75h.75V9h-.75Zm0-1.5h.75v-.75h-.75v.75Zm-6.012 0h-.75v.75h.75V7.5Zm-1.5-3.75h1.5v-1.5h-1.5v1.5Zm.75 3.75V3h-1.5v4.5h1.5ZM0 8.25h5.988v-1.5H0v1.5ZM.75 9V7.5h-1.5V9h1.5Zm5.238-.75H0v1.5h5.988v-1.5Zm.75 5.25V9h-1.5v4.5h1.5Zm.75-.75h-1.5v1.5h1.5v-1.5ZM6.738 9v4.5h1.5V9h-1.5Zm6.762-.75H7.488v1.5H13.5v-1.5Zm-.75-.75V9h1.5V7.5h-1.5Zm-5.262.75H13.5v-1.5H7.488v1.5ZM6.738 3v4.5h1.5V3h-1.5Z",
          mask: "url(#d)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fill: "#6DC2FF",
        stroke: "#F7FCFF",
        strokeWidth: ".25",
        d: "M19.463 17.848c-.782 0-1.334-.185-1.73-.514-.399-.33-.655-.82-.818-1.46-.163-.642-.23-1.424-.254-2.327-.017-.634-.014-1.324-.01-2.062l.002-.835h5.684c.102 1.825.143 3.618-.217 4.963-.184.685-.469 1.242-.892 1.628-.42.383-.99.607-1.765.607Z"
      }), /*#__PURE__*/_jsx("mask", {
        id: "e",
        width: "7",
        height: "8",
        x: "16",
        y: "10",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: ".25",
          d: "M19.463 17.848c-.782 0-1.334-.185-1.73-.514-.399-.33-.655-.82-.818-1.46-.163-.642-.23-1.424-.254-2.327-.017-.634-.014-1.324-.01-2.062l.002-.835h5.684c.102 1.825.143 3.618-.217 4.963-.184.685-.469 1.242-.892 1.628-.42.383-.99.607-1.765.607Z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#e)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#E1E5E8",
          fillRule: "evenodd",
          d: "M18.391 13.19s-.296-.219-.422-.573c-.127-.355-.379-1.3-.379-1.381 0-.082-.334 0-.334 0s.005-.4.131-.4.13-.37.437-.277c.306.094.546.436.858.436.312 0 1.616.099 1.825.099.21 0 .762.442.762.773s-.15.825-.27.825c-.118 0-.267.287-.492.192-.225-.095-.763-.29-1.244-.192-.482.097-.58.036-.58.192s-.292.306-.292.306Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#49801E",
          fillRule: "evenodd",
          d: "M17.7 12.959h3.867l-.666.86h-2.732l-.469-.86Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#fff",
          strokeWidth: ".533",
          d: "M17.65 16.722s.668.239.947.21c.31-.032.583-.385.79-.385.206 0 .604.353.912.385.28.029.826-.21.826-.21M16.916 15.702c.23-.195.734-.21.734-.21s.668.24.947.21c.31-.032.583-.385.79-.385.206 0 .604.353.912.385.28.03.826-.21.826-.21s.304-.343.687.02"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "m16.846 14.647-.506-.62c.198-.161.531-.32 1.017-.497l.236-.011c.504.129.841.185.964.173.041-.004.11-.037.233-.12.353-.234.388-.253.597-.253.192 0 .231.018.631.235.075.04.103.054.143.073.084.04.145.061.178.065.096.01.29-.036.56-.144.353-.32.799-.287 1.183.062.256.234.461.422.616.566l-.544.586c-.153-.142-.357-.329-.611-.56-.101-.093-.08-.092-.124-.043l-.139.097c-.42.177-.752.259-1.02.232a1.324 1.324 0 0 1-.445-.14 3.99 3.99 0 0 1-.177-.09c-.193-.105-.266-.139-.25-.139.033 0-.014.026-.155.12-.228.15-.386.228-.596.249-.231.023-.593-.033-1.121-.164-.343.13-.571.242-.67.323Z"
        })]
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#B85F3C",
        strokeWidth: ".5",
        d: "M17.222 16.795s.738.707.293 1.186c-.446.479-.854.2-.854.2M21.787 16.795s-.738.707-.292 1.186.854.2.854.2"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#CB8B73",
        strokeWidth: ".5",
        d: "M16.74 17.365s1.272 1.215 2.835 1.215 2.82-.928 2.82-.928"
      })]
    })]
  })]
}));
//# sourceMappingURL=FalklandIslands.js.map